<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <div class="row">
      <div class="col-md-4">
        <select class="form-select" :class="typeErrorMessage ? 'is-invalid' : ''" v-model="typeValue">
          <option />
          <option v-for="option in $constant.LICENCE.TYPE_LIST" :key="option.code" :value="option.code">
            {{ option.name }}
          </option>
        </select>
        <div class="invalid-feedback">{{ typeErrorMessage }}</div>
      </div>
      <div class="col-md-8">
        <input type="text" class="form-control" :class="numberErrorMessage ? 'is-invalid' : ''" v-model="numberValue">
        <div class="invalid-feedback">{{ numberErrorMessage }}</div>
      </div>
    </div>
  </form-layout>
</template>

<script>
import BaseVuexFormItem from '@/views/molecules/formItems/BaseVuexFormItem'
import FormLayout from '@/views/templates/FormLayout'

export default {
  name: "VuexLicenceFormItem",
  extends: BaseVuexFormItem,
  props: {
    label: {
      type: String,
      required: false,
      default: '宅地建物取引業免許番号'
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    bind: {
      type: String,
      default: '',
    },
    bindType: {
      type: String,
      default: 'licence_type'
    },
    bindNumber: {
      type: String,
      default: 'licence_number'
    },
  },
  components: {
    FormLayout,
  },
  inject: [
    '$constant'
  ],
  data() {
    return {
      vuex_type_column: '',
      vuex_number_column: '',
    }
  },
  created() {
    if (this.bindModule) {
      this.vuex_type_column = this.bindType;
      this.vuex_number_column = this.bindNumber;
    } else {
      const splitBindType = this.bindType.split('/');
      this.vuex_type_column = splitBindType.split('/').pop();
      this.vuex_number_column = this.bindNumber.split('/').pop();
      this.vuex_module = splitBindType.join('/');
    }
  },
  computed: {
    typeValue: {
      get() {
        return this._getter(this.vuex_type_column);
      },
      set(value) {
        this._commit(this.vuex_type_column, value);
      },
    },
    numberValue: {
      get() {
        return this._getter(this.vuex_number_column);
      },
      set(value) {
        this._commit(this.vuex_number_column, value);
      },
    },
    typeErrorMessage() {
      return this.$store.state[this.vuex_module]?.errors?.[this.vuex_type_column]?.[0];
    },
    numberErrorMessage() {
      return this.$store.state[this.vuex_module]?.errors?.[this.vuex_number_column]?.[0];
    },
  },
}
</script>
